import Vue from 'vue'
import moment from 'moment'
import 'moment/locale/zh-cn'

moment.locale('zh-cn')

Vue.filter('dateFilter', function (text, pattern = 'YYYY-MM-DD') {
  return text && moment(text).format(pattern)
})

Vue.filter('minutes', function (text, pattern = 'YYYY-MM-DD HH:mm') {
  return text && moment(text).format(pattern)
})

Vue.filter('time', function (text, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return text && moment(text).format(pattern)
})
